import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/platform/AuthContext";
import { FullScreenLoader } from "@/platform/components/primitives";

// Guards authenticated app routes. While the session is being verified we
// show a loader (three-state: null-ish loading -> user or redirect).
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// For /signup and /login: bounce already-authenticated users into the app.
export function PublicOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}
